import { type MCPServerInfo } from '../../types';

const SalesforceServer: MCPServerInfo = {
  serverId: 'SALESFORCE',
  name: 'Salesforce',
  slug: 'salesforce',
  description: 'Salesforce MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/tsmztech/mcp-server-salesforce',
    commitSha: 'd57c0a9',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [
      'salesforceClientId',
      'salesforceClientSecret',
      'salesforceConnectionType',
      'salesforceInstanceUrl'
    ],
    properties: {
      salesforceClientId: {
        type: 'string',
        description: 'SalesforceClient ID',
        sensitive: false
      },
      salesforceClientSecret: {
        type: 'string',
        description: 'SalesforceClientSecret',
        sensitive: true
      },
      salesforceConnectionType: {
        type: 'string',
        description: 'SalesforceConnectionType',
        sensitive: false,
        default: 'OAuth_2.0_Client_Credentials'
      },
      salesforceInstanceUrl: {
        type: 'string',
        description: 'SalesforceInstance URL',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default SalesforceServer;
